//JavaScript Document
import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import "../../assets/css/ant-design.css";
import "../../assets/css/home.css";

import {
	ConfigProvider,
	Menu,
	Dropdown,
	Icon,
	Modal,
	Spin,
	message,
} from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import {
	axios,
	systemManagerRest,
	systemManagerTobRest,
	requestWithSignInJson,
	getAccessPage,
	clientId,
} from "../../api";
import {
	configUserCenter,
	login as usercenterLogin,
	logout as usercenterLogout,
	reLogin,
} from "@haier/fe-stub-usercenter";
configUserCenter({
	clientId: clientId,
	ssoUrl: "https://iama.haier.net",
	tokenUrl: `/system-manager-rest/iam/${clientId}/token`,
});
class App extends Component {
	constructor() {
		super();
		this.state = {
			userInfo: new Object(),
			visible: false, //是否显示个人信息弹框
			loading: false,
		};
		this.dropdown = (
			<Menu>
				<Menu.Item onClick={this.toggleModal}>
					<a href="javascript:void(0);">个人信息</a>
				</Menu.Item>
				<Menu.Item onClick={this.handleLogout}>
					<a href="javascript:void(0);">退出</a>
				</Menu.Item>
			</Menu>
		);
	}
	render() {
		let {
			userInfo: {
				usercode,
				fullname,
				gender,
				userstate,
				prodLineName,
				deptname,
				position,
				notesemail,
			} = new Object(),
			visible = false,
			loading = false,
		} = this.state;
		let userId = localStorage.getItem("lifecyclemp-userId");
		return (
			<ConfigProvider locale={zhCN}>
				<Fragment>
					<header>
						<div className="header">
							<div
								className="logo"
								onClick={() =>
									(window.location.href = "/lifecyclemp/build/index.html")
								}>
								<img
									src="/lifecyclemp/assets/images/logoNew.png"
									alt=""
									height="40"
								/>
								<h3>智家场景体验运营平台</h3>
							</div>
							<div className={userId ? "menu2" : "menu"}>
								<a href="#">首页</a>
								<a
									href="https://ihaier.feishu.cn/wiki/wikcnu0HGGS0ekurX3i4QReg3oh"
									target="view_window">
									更新日志
								</a>
								<a
									href="https://ihaier.feishu.cn/wiki/RAG3wcwUciF9lGkQ72gcTKjHnCg"
									target="view_window">
									帮助手册
									{/* href="https://ihaier.feishu.cn/wiki/wikcn9mWLHDyUGcPhcBbznyp6iX" */}
								</a>
								<a
									href="https://ihaier.feishu.cn/share/base/form/shrcno4Nhll086CfYqnNwoBQILe"
									target="view_window">
									申请权限
									{/* href="https://bpmuac.haier.net/isc_mp_auth/isc_flow_auth/jsp/order/workOrderEntry.jsp" */}
								</a>
								{userId ? (
									<Dropdown overlay={this.dropdown}>
										<a className="ant-dropdown-link" href="javascript:void(0);">
											欢迎您，{fullname}&nbsp;
											<Icon type="down" />
										</a>
									</Dropdown>
								) : (
									<a className="loginBtn" onClick={() => this.login()}>
										登录
									</a>
								)}
							</div>
						</div>
					</header>
					{this.props.children}
					<Modal
						title="个人信息"
						width={584}
						maskClosable={false}
						visible={visible}
						onOk={this.toggleModal}
						onCancel={this.toggleModal}>
						<div className="modal">
							<ul className="clearfix">
								<li className="float-left">
									<b>员工号：</b>
									<span>{usercode}</span>
								</li>
								<li className="float-left">
									<b>姓名：</b>
									<span>{fullname}</span>
								</li>
								<li className="float-left">
									<b>性别：</b>
									<span>
										{parseInt(gender) == 1
											? "男"
											: parseInt(gender) == 2
											? "女"
											: null}
									</span>
								</li>
								<li className="float-left">
									<b>状态：</b>
									<span>{parseInt(userstate) == 1 ? "启用" : "禁用"}</span>
								</li>
								<li className="float-left">
									<b>产业：</b>
									<span>{prodLineName}</span>
								</li>
								<li className="float-left">
									<b>部门：</b>
									<span>{deptname}</span>
								</li>
								<li className="float-left">
									<b>职位：</b>
									<span>{position}</span>
								</li>
								<li className="float-left">
									<b>邮箱：</b>
									<span>{notesemail}</span>
								</li>
							</ul>
						</div>
					</Modal>
					<Spin
						size="large"
						spinning={loading}
						style={{
							width: "100vw",
							height: "100vh",
							position: "fixed",
							top: 0,
							left: 0,
							backgroundColor: "rgba(200,200,200,0.5)",
						}}
					/>
				</Fragment>
			</ConfigProvider>
		);
	}
	componentDidMount() {
		// let haierToken = localStorage.getItem("haier-user-center-access-token");
		let lifecyclempToken = localStorage.getItem(
			"lifecyclemp-Access-User-Token"
		);
		this.setState({ loading: true });
		let search = window.location.href.substr(
			window.location.href.indexOf("?") + 1
		);
		if (search && search.indexOf("token") > -1) {
			let token = search
				.split("&")
				.filter((s) => s.indexOf("token") > -1)[0]
				.split("=")[1];
			this.checkToken(token);
		} else if (lifecyclempToken) {
			this.checkToken(lifecyclempToken);
		} else {
			usercenterLogin().then((res) => {
				if (res.token) {
					this.exchangeToken(res.token);
				} else {
					this.loadSuccess();
				}
				if (res.userInfo) {
					let { nickName } = res.userInfo;
					let userInfo = this.state.userInfo;
					userInfo.fullname = nickName;
					this.setState({
						userInfo,
					});
				}
			});
		}
	}
	loadSuccess = () => {
		this.setState({ loading: false });
	};
	checkToken = (token) => {
		axios({
			method: "GET",
			url: `${systemManagerRest}/token/validate/${token}`,
		})
			.then(({ id, name, type }) => {
				if (!id || !name) {
					window.__WORK_NO__ = undefined;
					window.localStorage.removeItem("lifecyclemp-Access-User-Token");
					window.localStorage.removeItem("lifecyclemp-dimPermissions");
					window.localStorage.removeItem("lifecyclemp-modulePermission");
					window.localStorage.removeItem("lifecyclemp-userType");
					window.localStorage.removeItem("lifecyclemp-userId");
					window.localStorage.removeItem("lifecyclemp-moduleMenu");
					window.localStorage.removeItem("lifecyclemp-groupMenu");
					window.localStorage.removeItem("lifecyclemp-pageMenu");
					this.loadSuccess();
					this.login();
				} else {
					window.__WORK_NO__ = name;
					window.localStorage.setItem("lifecyclemp-userId", name);
					window.localStorage.setItem("lifecyclemp-userType", type);
					window.localStorage.setItem("lifecyclemp-Access-User-Token", token);
					axios.defaults.headers.common["Access-User-Token"] = token;
					if (this.props.homeRef.current) {
						this.props.homeRef.current.getMenu(this.loadSuccess);
					} else {
						this.loadSuccess();
					}
					this.getUserInfo();
				}
			})
			.catch((e) => {
				this.loadSuccess();
				message.error("token 校验失败");
				console.error(e);
				this.handleLogout();
			});
	};
	login = () => {
		usercenterLogin().then((res) => {
			if (res.token) {
				this.exchangeToken(res.token);
			} else {
				this.loadSuccess();
			}
			if (res.userInfo) {
				let { nickName } = res.userInfo;
				let userInfo = this.state.userInfo;
				userInfo.fullname = nickName;
				this.setState({
					userInfo,
				});
			}
		});
	};
	exchangeToken = async (access_token) => {
		axios({
			method: "post",
			url: `${systemManagerRest}/token/exchange`,
			headers: {
				"Content-Type": "application/json; charset=UTF-8",
				"Access-Page": getAccessPage({
					//埋点字段
					module: "首页",
					operation: "query",
				}),
			},
			transformRequest: [
				function (data, headers) {
					return JSON.stringify(data);
				},
			],
			data: { accessToken: access_token, sysCode: "Unified-platform" },
		})
			.then((resp) => {
				if (resp.data) {
					let token = resp.data["Access-User-Token"];
					window.localStorage.setItem("lifecyclemp-userId", resp.data.username);
					window.localStorage.setItem("lifecyclemp-Access-User-Token", token);
					window.__WORK_NO__ = resp.data.username;
					axios.defaults.headers.common["Access-User-Token"] = token;
					if (this.props.homeRef.current) {
						this.props.homeRef.current.getMenu(this.loadSuccess);
					} else {
						this.loadSuccess();
					}
					this.getUserInfo();
				} else {
					this.loadSuccess();
					reLogin();
				}
			})
			.catch((e) => {
				message.error("token换取接口请求失败");
				console.error(e);
				this.loadSuccess();
				this.handleLogout();
			});
	};
	getUserInfo = () => {
		//获取用户信息
		//return await requestWithSignInJson({
		requestWithSignInJson({
			method: "POST",
			url: `${systemManagerTobRest}/user/getUser`,
			data: {
				userId: window.localStorage.getItem("lifecyclemp-userId"),
				type: window.localStorage.getItem("lifecyclemp-userType") || "ldap",
			},
			accessPage: getAccessPage({
				//埋点字段
				module: "菜单首页",
				operation: "query",
			}),
		})
			.then((userInfo) => {
				if (userInfo.retCode == 0) {
					this.setState((prevState, props) => ({
						userInfo: userInfo.data,
					}));
				} else {
					if (window.localStorage.getItem("lifecyclemp-userId")) {
						let userInfo = {
							fullname: window.localStorage.getItem("lifecyclemp-userId"),
						};
						this.setState({ userInfo });
					} else {
						message.warning(`未知用户(${userInfo.retCode})`);
					}
				}
			})
			.catch((e) => {
				let search = location.search;
				let object = {};
				search.replace(/([^?=&#]+)=([^?=&#]+)?/g, function () {
					object[arguments[1]] = arguments[2] || "";
				});
				if (object.hdpagetype && object.hdpagetype === "HAIER_DATA") {
				} else {
					if (e.response.status == 401) {
						this.handleLogout();
					}
				}
			});
	};
	toggleModal = () =>
		this.setState((prevState, props) => ({
			visible: !prevState.visible,
		}));

	handleLogout = () => {
		window.localStorage.removeItem("lifecyclemp-Access-User-Token");
		window.localStorage.removeItem("lifecyclemp-dimPermissions");
		window.localStorage.removeItem("lifecyclemp-modulePermission");
		window.localStorage.removeItem("lifecyclemp-userType");
		window.localStorage.removeItem("lifecyclemp-userId");
		window.localStorage.removeItem("lifecyclemp-moduleMenu");
		window.localStorage.removeItem("lifecyclemp-groupMenu");
		window.localStorage.removeItem("lifecyclemp-pageMenu");
		usercenterLogout();
	};
}
export default withRouter(App);
